import { cn } from "@/utils/className";
import React from "react";
import { Link } from "react-router-dom";


interface LinkArrowButtonProps {
  href: string;
  label?: string;
  className?: string;
  iconSrc?: string;
  target?: "_blank" | "_self";
  rel?: string;
  onClick?: () => void;
  loading?: boolean;
}

export const LinkArrowButton: React.FC<LinkArrowButtonProps> = ({
  href,
  label,
  className,
  iconSrc = "/images/icons/icon-link-arrow.svg",
  target = "_self",
  rel,
  onClick,
  loading = false,
}) => {
  return (
    <Link
      to={href}
      target={target}
      rel={rel}
      onClick={(e) => {
        if (onClick) {
          e.preventDefault();
          onClick();
        }
      }}
      className={cn("link-arrow", className)}
    >
      <span className="icon">
        <img src={iconSrc} alt="" />
      </span>
      <span className="text">
        {loading ? (
          <div className="flex gap-2 mt-1">
            <span
              className="w-2.5 h-2.5 rounded-full bg-[#181A20] animate-bounce"
              style={{ animationDelay: "0s" }}
            />
            <span
              className="w-2.5 h-2.5 rounded-full bg-[#8793A9] animate-bounce"
              style={{ animationDelay: "0.2s" }}
            />
            <span
              className="w-2.5 h-2.5 rounded-full bg-[#D1F99C] animate-bounce"
              style={{ animationDelay: "0.4s" }}
            />
          </div>
        ) : (
          label || ""
        )}
      </span>
    </Link>
  );
};
